<template>
  <div>
    <PageAllow controller="OrderRulers" action="show" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row class="mx-2">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab v-for="tabTitle in tabTitles" :key="tabTitle.title">
                <h4>{{ tabTitle.title }}</h4>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-tabs-items
          v-model="tab"
          class="transparent-background-color pb-4 mt-1"
        >
          <!-- 最小订货规则type=1 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'minQuantity')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <v-btn
                  v-if="
                    $permission.permissionAllow(
                      'OrderRulers',
                      'saveMinQuantity'
                    )
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push(
                        'material-order-rules/min_quantity/0?type=' + 1
                      );
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.minOrderRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>

              <v-data-table
                :headers="headersOne"
                :items="minOrderRules"
                :loading="loading"
                :options.sync="options1"
                :page.sync="paging1.page"
                :server-items-length="paging1.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.conditions.must_flg="{ item }">
                  <span v-if="item.conditions && item.conditions.must_flg">
                    {{ item.conditions.must_flg | mustVerifyFlgsText }}
                  </span>
                  <span v-else>
                    {{ 0 | mustVerifyFlgsText }}
                  </span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'minQuantityView'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/min_quantity/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveMinQuantity'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/min_quantity/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'minQuantityDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 最大订货规则type=3 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'maxQuantity')"
          >
            <v-card class="mx-3">
              <v-list rounded>
                <v-subheader>
                  <v-spacer />
                  <v-btn
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveMaxQuantity'
                      )
                    "
                    small
                    color="primary"
                    @click.stop="
                      $permission.checkAccountExpired().then(() => {
                        $router.push(
                          'material-order-rules/max_quantity/0?type=' + 3
                        );
                      })
                    "
                    class="ms-1 mx-1"
                  >
                    <v-icon x-small class="pe-1">fa-plus</v-icon>
                    {{
                      $t("CRUD.newInfo", [
                        $t("MaterialOrderRule.maxOrderRule.title"),
                      ])
                    }}
                  </v-btn>
                </v-subheader>

                <v-data-table
                  :headers="headersOne"
                  :items="maxOrderRules"
                  :loading="loading"
                  :options.sync="options3"
                  :page.sync="paging3.page"
                  :server-items-length="paging3.count"
                  multi-sort
                  class="px-4"
                  :footer-props="footerProps"
                >
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <template v-slot:item.match_flg="{ item }">
                    {{ item.match_flg | applicationWaysText }}
                  </template>
                  <template v-slot:item.conditions.must_flg="{ item }">
                    <span v-if="item.conditions && item.conditions.must_flg">
                      {{ item.conditions.must_flg | mustVerifyFlgsText }}
                    </span>
                    <span v-else>
                      {{ 0 | mustVerifyFlgsText }}
                    </span>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.status | orderRuleStatusColor"
                      :text-color="item.status | orderRuleStatusTextColor"
                    >
                      {{ item.status | orderRuleStatusText }}
                    </v-chip>
                  </template>
                  <template v-slot:item.created="{ item }">
                    {{ item.created | formatTime }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <!-- 详情 -->
                    <v-tooltip
                      top
                      v-if="
                        $permission.permissionAllow(
                          'OrderRulers',
                          'maxQuantityView'
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="secondary"
                          class="px-1 me-1"
                          @click.stop="
                            $permission.checkAccountExpired().then(() => {
                              $router.push({
                                path:
                                  'material-order-rules/max_quantity/' +
                                  item.id,
                                query: { type: item.type, mode: 'view' },
                              });
                            })
                          "
                          >fa-file-alt
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("CRUD.viewInfo", [
                            $t("MaterialOrderRule.ObjectName"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      v-if="
                        $permission.permissionAllow(
                          'OrderRulers',
                          'saveMaxQuantity'
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          class="px-1 py-4 me-1"
                          @click.stop="
                            $permission.checkAccountExpired().then(() => {
                              $router.push({
                                path:
                                  'material-order-rules/max_quantity/' +
                                  item.id,
                                query: { type: item.type, mode: 'edit' },
                              });
                            })
                          "
                          >fa-pencil-alt
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("CRUD.editInfo", [
                            $t("MaterialOrderRule.ObjectName"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      v-if="
                        !item.status &&
                        $permission.permissionAllow(
                          'OrderRulers',
                          'maxQuantityDelete'
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="danger"
                          class="px-1 me-1"
                          @click.stop="
                            deleteItem = item;
                            deleteDialog = true;
                          "
                          >fa-trash-alt
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("CRUD.deleteInfo", [
                            $t("MaterialOrderRule.ObjectName"),
                          ])
                        }}
                      </span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-list>
            </v-card>
          </v-tab-item>
          <!-- 数量匹配规则type=2 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'quantity')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <v-btn
                  v-if="
                    $permission.permissionAllow('OrderRulers', 'saveQuantity')
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('material-order-rules/quantity/0?type=' + 2);
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.numberMatchRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="headersTwo"
                :items="numberMatchRules"
                :loading="loading"
                :options.sync="options2"
                :page.sync="paging2.page"
                :server-items-length="paging2.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow('OrderRulers', 'quantityView')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path: 'material-order-rules/quantity/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow('OrderRulers', 'saveQuantity')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path: 'material-order-rules/quantity/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'quantityDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 自动标配规则type=5 -->
          <v-tab-item v-if="$permission.permissionAllow('OrderRulers', 'auto')">
            <v-sheet class="transparent-background-color">
              <v-row dense class="mx-5">
                <v-col cols="12" sm="12" md="4">
                  <v-row dense align="center" class="pa-1 pe-2">
                    <SearcherKeyword
                      ref="KeyWord"
                      v-model="options5.condition_key_word"
                      @text="KeyWord = $event"
                      :label="$t('MaterialOrderRule.conditionKeyWord')"
                    />
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="8" align-self="center">
                  <v-row dense align="center" class="search-controls">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          text
                          class="px-0 py-0 caption font-weight-bold grey--text"
                          color="primary"
                          @click.stop="onSearch()"
                        >
                          <v-icon small class="pe-1">fa-search</v-icon>
                          {{ $t("Search.search") }}
                        </v-btn>
                      </template>
                      <span>{{ $t("Search.searchTip") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          text
                          class="caption font-weight-bold grey--text"
                          @click.stop="resetSearch()"
                        >
                          <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                          {{ $t("Search.reset") }}
                        </v-btn>
                      </template>
                      <span>{{ $t("Search.resetTip") }}</span>
                    </v-tooltip>
                    <v-spacer />
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>

            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <v-btn
                  v-if="$permission.permissionAllow('OrderRulers', 'saveAuto')"
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push('material-order-rules/auto/0?type=' + 5);
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.autoStandardRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="headersTwo"
                :items="autoStandardRules"
                :loading="loading"
                :options.sync="options5"
                :page.sync="paging5.page"
                :server-items-length="paging5.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow('OrderRulers', 'autoView')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path: 'material-order-rules/auto/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow('OrderRulers', 'saveAuto')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path: 'material-order-rules/auto/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow('OrderRulers', 'autoDelete')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 最小订货金额规则type=4 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'minAmount')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <v-btn
                  v-if="
                    $permission.permissionAllow('OrderRulers', 'saveMinAmount')
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push(
                        'material-order-rules/min_amount/0?type=' + 4
                      );
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.minOrderMoneyRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="headersTwo"
                :items="minOrderMoneyRules"
                :loading="loading"
                :options.sync="options4"
                :page.sync="paging4.page"
                :server-items-length="paging4.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'minAmountView'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/min_amount/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveMinAmount'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/min_amount/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'minAmountDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 组合商品规则type=6 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'combineMaterial')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <!-- 新建规则按钮 -->
                <v-btn
                  v-if="
                    $permission.permissionAllow(
                      'OrderRulers',
                      'saveCombineMaterial'
                    )
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push(
                        'material-order-rules/combine_material/0?type=' + 6
                      );
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.mixProductRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="headersThree"
                :items="mixProductRules"
                :loading="loading"
                :options.sync="options6"
                :page.sync="paging6.page"
                :server-items-length="paging6.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                  <span v-if="item.expired_flg == 1">
                    ({{ $t("MaterialOrderRule.mixProductRule.off") }})
                  </span>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'combineMaterialView'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/combine_material/' +
                                item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 编辑操作 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveCombineMaterial'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/combine_material/' +
                                item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 删除操作 -->
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'combineMaterialDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 运费计算规则type=7 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'expressFee')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <!-- 新建规则按钮 -->
                <v-btn
                  v-if="
                    $permission.permissionAllow('OrderRulers', 'saveExpressFee')
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push(
                        'material-order-rules/express_fee/0?type=' + 7
                      );
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.expressFee.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="expressFeeHeaders"
                :items="expressFee"
                :loading="loading"
                :options.sync="options7"
                :page.sync="paging7.page"
                :server-items-length="paging7.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.memo="{ item }">
                  <span :title="item.memo" style="display: block;width: 100px;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;cursor: pointer">{{ item.memo }}</span>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'expressFeeView'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/express_fee/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 编辑操作 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveExpressFee'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/express_fee/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 删除操作 -->
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'expressFeeDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- 强制订货规则type=9 -->
          <v-tab-item
            v-if="$permission.permissionAllow('OrderRulers', 'forceOrder')"
          >
            <v-card class="mx-3">
              <v-subheader>
                <v-spacer />
                <!-- 新建规则按钮 -->
                <v-btn
                  v-if="
                    $permission.permissionAllow('OrderRulers', 'saveForceOrder')
                  "
                  small
                  color="primary"
                  @click.stop="
                    $permission.checkAccountExpired().then(() => {
                      $router.push(
                        'material-order-rules/force-order/0?type=' + 9
                      );
                    })
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{
                    $t("CRUD.newInfo", [
                      $t("MaterialOrderRule.forceOrderRule.title"),
                    ])
                  }}
                </v-btn>
              </v-subheader>
              <v-data-table
                :headers="headersTwo"
                :items="forceOrder"
                :loading="loading"
                :options.sync="options9"
                :page.sync="paging9.page"
                :server-items-length="paging9.count"
                multi-sort
                class="px-4"
                :footer-props="footerProps"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.match_flg="{ item }">
                  {{ item.match_flg | applicationWaysText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | orderRuleStatusColor"
                    :text-color="item.status | orderRuleStatusTextColor"
                  >
                    {{ item.status | orderRuleStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.created="{ item }">
                  {{ item.created | formatTime }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <!-- 详情 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'forceOrderView'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/force-order/' + item.id,
                              query: { type: item.type, mode: 'view' },
                            });
                          })
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.viewInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 编辑操作 -->
                  <v-tooltip
                    top
                    v-if="
                      $permission.permissionAllow(
                        'OrderRulers',
                        'saveForceOrder'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          $permission.checkAccountExpired().then(() => {
                            $router.push({
                              path:
                                'material-order-rules/force-order/' + item.id,
                              query: { type: item.type, mode: 'edit' },
                            });
                          })
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.editInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                  <!-- 删除操作 -->
                  <v-tooltip
                    top
                    v-if="
                      !item.status &&
                      $permission.permissionAllow(
                        'OrderRulers',
                        'forceOrderDelete'
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          deleteItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>
                      {{
                        $t("CRUD.deleteInfo", [
                          $t("MaterialOrderRule.ObjectName"),
                        ])
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-slide-x-transition>

    <!-- 删除规则弹出框 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('MaterialOrderRule.ObjectName')"
      @confirm="
        deleteRule();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogDelete from "@/components/plugins/DialogDelete";
import OrderRules from "@/api/order_rules";
import SearcherKeyword from "@/components/plugins/SearcherKeyword.vue";

export default {
  components: {
    SearcherKeyword,
    PageAllow,
    Breadcrumbs,
    DialogDelete,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialOrderRules"),
          disabled: true,
          href: "/material-order-rules",
        },
      ];
    },

    headersOne: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.rule_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.application_districts"),
        align: "start",
        sortable: false,
        value: "match_flg",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.must_verify"),
        align: "start",
        sortable: false,
        value: "conditions.must_flg",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    headersTwo: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.rule_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.application_districts"),
        align: "start",
        sortable: false,
        value: "match_flg",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    headersThree: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.rule_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.application_districts"),
        align: "start",
        sortable: false,
        value: "match_flg",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("TableHeaders.priority"),
        align: "start",
        sortable: false,
        value: "sort",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    expressFeeHeaders: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.rule_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("MaterialOrderRule.expressFee.memo"),
        align: "start",
        sortable: false,
        value: "memo",
        width: 200,
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.application_districts"),
        align: "start",
        sortable: false,
        value: "match_flg",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    tabTitles() {
      var titles = [];
      if (this.$permission.permissionAllow("OrderRulers", "minQuantity")) {
        titles.push({
          title: i18n.t("MaterialOrderRule.minOrderRule.title"),
          type: 1,
        });
      }
      if (this.$permission.permissionAllow("OrderRulers", "maxQuantity")) {
        titles.push({
          title: i18n.t("MaterialOrderRule.maxOrderRule.title"),
          type: 3,
        });
      }
      if (this.$permission.permissionAllow("OrderRulers", "quantity")) {
        titles.push({
          title: i18n.t("MaterialOrderRule.numberMatchRule.title"),
          type: 2,
        });
      }
      if (this.$permission.permissionAllow("OrderRulers", "auto")) {
        titles.push({
          title: i18n.t("MaterialOrderRule.autoStandardRule.title"),
          type: 5,
        });
      }
      if (this.$permission.permissionAllow("OrderRulers", "minAmount")) {
        titles.push({
          title: i18n.t("MaterialOrderRule.minOrderMoneyRule.title"),
          type: 4,
        });
      }
      if (this.$LogoFolder != "fengputech/") {
        if (
          this.$permission.permissionAllow("OrderRulers", "combineMaterial")
        ) {
          titles.push({
            title: i18n.t("MaterialOrderRule.mixProductRule.title"),
            type: 6,
          });
        }
        if (this.$permission.permissionAllow("OrderRulers", "expressFee")) {
          titles.push({
            title: i18n.t("MaterialOrderRule.expressFee.title"),
            type: 7,
          });
        }
        if (this.$permission.permissionAllow("OrderRulers", "forceOrder")) {
          titles.push({
            title: i18n.t("MaterialOrderRule.forceOrderRule.title"),
            type: 9,
          });
        }
      }

      // switch (this.$LogoFolder) {
      //   case "fengputech/":
      //     break;
      //   default:
      //     titles.push({
      //       title: i18n.t("MaterialOrderRule.mixProductRule.title"),
      //       type: 6,
      //     });
      //     titles.push({
      //       title: i18n.t("MaterialOrderRule.expressFee.title"),
      //       type: 7,
      //     });
      //     break;
      // }
      return titles;
    },
    footerProps() {
      let props = Object.assign({}, i18n.t("$config.footer-props"));
      props.itemsPerPageOptions = [...props.itemsPerPageOptions, -1];
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    tab: null,
    orderRules: [],
    minOrderRules: [],
    maxOrderRules: [],
    numberMatchRules: [],
    autoStandardRules: [],
    minOrderMoneyRules: [],
    mixProductRules: [],
    expressFee: [],
    forceOrder: [],
    deleteDialog: false,
    deleteItem: {},
    options1: {},
    paging1: {},
    options2: {},
    paging2: {},
    options3: {},
    paging3: {},
    options4: {},
    paging4: {},
    options5: {},
    paging5: {},
    options6: {},
    paging6: {},
    options7: {},
    paging7: {},
    options9: {},
    paging9: {},
    KeyWord: "",
  }),

  mounted() {
    if (this.$route.query.type == 1) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 1);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 2) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 2);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 3) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 3);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 4) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 4);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 5) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 5);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 6) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 6);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 7) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 7);
      this.$router.replace("/material-order-rules");
    } else if (this.$route.query.type == 9) {
      this.tab = this.tabTitles.findIndex((tab) => tab.type == 9);
      this.$router.replace("/material-order-rules");
    }
    this.$commonUtils
      .loadOptions("material-order-rules-" + this.tabTitles[this.tab].type, [])
      .then(
        function (data) {
          if (data.options) {
            this.setOptions(data.options);
          }
        }.bind(this)
      );
  },

  methods: {
    getOrderRulesFromAPI() {
      OrderRules.fetch(this.getPostData()).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orderRules = response.data.order_rulers;
            this.setPaging(response.data.paging)
            // this.paging[this.tabTitles[this.tab].type] = response.data.pageing
          }
        }.bind(this)
      );
    },
    deleteRule() {
      if (this.deleteItem.id) {
        OrderRules.del(this.deleteItem.id, {
          type: this.tabTitles[this.tab].type,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              // if (this.tab == null || this.tab == 0) {
              //   this.getOrderRulesFromAPI({ type: 1 });
              // } else if (this.tab == 1) {
              //   this.getOrderRulesFromAPI({ type: 3 });
              // } else if (this.tab == 2) {
              //   this.getOrderRulesFromAPI({ type: 2 });
              // } else if (this.tab == 3) {
              //   this.getOrderRulesFromAPI({ type: 5 });
              // } else if (this.tab == 4) {
              //   this.getOrderRulesFromAPI({ type: 4 });
              // } else if (this.tab == 5) {
              //   this.getOrderRulesFromAPI({ type: 6 });
              // } else if (this.tab == 6) {
              //   this.getOrderRulesFromAPI({ type: 7 });
              // }

              // if (this.tabTitles[this.tab].type == 1) {
              //   this.getOrderRulesFromAPI({ type: 1 });
              // } else if (this.tabTitles[this.tab].type == 3) {
              //   this.getOrderRulesFromAPI({ type: 3 });
              // } else if (this.tabTitles[this.tab].type == 2) {
              //   this.getOrderRulesFromAPI({ type: 2 });
              // } else if (this.tabTitles[this.tab].type == 5) {
              //   this.getOrderRulesFromAPI({ type: 5 });
              // } else if (this.tabTitles[this.tab].type == 4) {
              //   this.getOrderRulesFromAPI({ type: 4 });
              // } else if (this.tabTitles[this.tab].type == 6) {
              //   this.getOrderRulesFromAPI({ type: 6 });
              // } else if (this.tabTitles[this.tab].type == 7) {
              //   this.getOrderRulesFromAPI({ type: 7 });
              // } else if (this.tabTitles[this.tab].type == 9) {
              //   this.getOrderRulesFromAPI({ type: 9 });
              // }
            }
          }.bind(this)
        );
      }
    },
    setOptions(option) {
      if (this.tabTitles[this.tab].type == 1) {
        this.options1 = option;
      } else if (this.tabTitles[this.tab].type == 3) {
        this.options3 = option
      } else if (this.tabTitles[this.tab].type == 2) {
        this.options2 = option
      } else if (this.tabTitles[this.tab].type == 5) {
        this.options5 = option
      } else if (this.tabTitles[this.tab].type == 4) {
        this.options4 = option
      } else if (this.tabTitles[this.tab].type == 6) {
        this.options6 = option
      } else if (this.tabTitles[this.tab].type == 7) {
        this.options7 = option
      } else if (this.tabTitles[this.tab].type == 9) {
        this.options9 = option
      }
    },
    setPaging(paging) {
      if (this.tabTitles[this.tab].type == 1) {
        this.paging1 = paging;
      } else if (this.tabTitles[this.tab].type == 3) {
        this.paging3 = paging
      } else if (this.tabTitles[this.tab].type == 2) {
        this.paging2 = paging
      } else if (this.tabTitles[this.tab].type == 5) {
        this.paging5 = paging
      } else if (this.tabTitles[this.tab].type == 4) {
        this.paging4 = paging
      } else if (this.tabTitles[this.tab].type == 6) {
        this.paging6 = paging
      } else if (this.tabTitles[this.tab].type == 7) {
        this.paging7 = paging
      } else if (this.tabTitles[this.tab].type == 9) {
        this.paging9 = paging
      }
    },
    getPostData() {
      let postData = {};
      if (this.tabTitles[this.tab].type == 1) {
        postData = Object.assign({}, this.options1, {
          type: 1
        });
      }
      else if (this.tabTitles[this.tab].type == 3) {
        postData = Object.assign({}, this.options3, {
          type: 3
        });
      } else if (this.tabTitles[this.tab].type == 2) {
        postData = Object.assign({}, this.options2, {
          type: 2
        });
      } else if (this.tabTitles[this.tab].type == 5) {
        postData = Object.assign({}, this.options5, {
          type: 5
        });
      } else if (this.tabTitles[this.tab].type == 4) {
        postData = Object.assign({}, this.options4, {
          type: 4
        });
      } else if (this.tabTitles[this.tab].type == 6) {
        postData = Object.assign({}, this.options6, {
          type: 6
        });
      } else if (this.tabTitles[this.tab].type == 7) {
        postData = Object.assign({}, this.options7, {
          type: 7
        });
      } else if (this.tabTitles[this.tab].type == 9) {
        postData = Object.assign({}, this.options9, {
          type: 9
        });
      }
      return postData;
    },
    onSearch(){
      this.options5 = Object.assign({}, this.options5, {
        condition_key_word: this.KeyWord,
      });
    },
    resetSearch() {
      this.options5 = {};
      [this.$refs.KeyWord].forEach((k) => {
        if (k) k.clear();
      });
    }
  },

  watch: {
    tab: {
      immediate: true,
      handler() {
        // if (this.tab == null || this.tab == 0) {
        //   this.getOrderRulesFromAPI({ type: 1 });
        // } else if (this.tab == 1) {
        //   this.getOrderRulesFromAPI({ type: 3 });
        // } else if (this.tab == 2) {
        //   this.getOrderRulesFromAPI({ type: 2 });
        // } else if (this.tab == 3) {
        //   this.getOrderRulesFromAPI({ type: 5 });
        // } else if (this.tab == 4) {
        //   this.getOrderRulesFromAPI({ type: 4 });
        // } else if (this.tab == 5) {
        //   this.getOrderRulesFromAPI({ type: 6 });
        // } else if (this.tab == 6) {
        //   this.getOrderRulesFromAPI({ type: 7 });
        // }
        // if (this.tab != null) {
        //   this.getOrderRulesFromAPI();
        // }
      },
    },
    orderRules: {
      deep: true,
      handler() {
        if (this.tabTitles[this.tab].type == 1) {
          this.minOrderRules = JSON.parse(JSON.stringify(this.orderRules));
        } else if (this.tabTitles[this.tab].type == 3) {
          this.maxOrderRules = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 2) {
          this.numberMatchRules = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 5) {
          this.autoStandardRules = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 4) {
          this.minOrderMoneyRules = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 6) {
          this.mixProductRules = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 7) {
          this.expressFee = JSON.parse(JSON.stringify(this.orderRules));
        }
        if (this.tabTitles[this.tab].type == 9) {
          this.forceOrder = JSON.parse(JSON.stringify(this.orderRules));
        }
        // if (this.tab == null || this.tab == 0) {
        //   this.minOrderRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 1) {
        //   this.maxOrderRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 2) {
        //   this.numberMatchRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 3) {
        //   this.autoStandardRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 4) {
        //   this.minOrderMoneyRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 5) {
        //   this.mixProductRules = JSON.parse(JSON.stringify(this.orderRules));
        // } else if (this.tab == 6) {
        //   this.expressFee = JSON.parse(JSON.stringify(this.orderRules));
        // }
      },
    },
    deleteDialog: {
      handler() {
        if (!this.deleteDialog) {
          this.deleteItem = {};
        }
      },
    },
    options1: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-1-options",
            JSON.stringify(this.options1)
        );
      },
    },
    options2: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-2-options",
            JSON.stringify(this.options2)
        );
      },
    },
    options3: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-3-options",
            JSON.stringify(this.options3)
        );
      },
    },
    options4: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-4-options",
            JSON.stringify(this.options4)
        );
      },
    },
    options5: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-5-options",
            JSON.stringify(this.options5)
        );
      },
    },
    options6: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-6-options",
            JSON.stringify(this.options6)
        );
      },
    },
    options7: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-7-options",
            JSON.stringify(this.options7)
        );
      },
    },
    options9: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getOrderRulesFromAPI();
        sessionStorage.setItem(
            "material-order-rules-9-options",
            JSON.stringify(this.options9)
        );
      },
    },
  },
};
</script>
